// extracted by mini-css-extract-plugin
module.exports = {"center":"_3Rc9I","justify":"r7ki9","left":"_2UjLI","right":"_1x_Jp"};